import React from 'react';
import { useIntl } from 'react-intl';

import Box from 'carbon-react/lib/components/box';
import { LoaderSpinner } from 'carbon-react/lib/components/loader-spinner';

export interface SfaLoadingProps {
  text?: string;
}

export const SfaLoading = ({ text }: SfaLoadingProps) => {
  const intl = useIntl();

  const defaultText = intl.formatMessage({
    id: 'common.loading_please_wait',
    defaultMessage: 'Loading, please wait...'
  });

  return (
    <Box display="flex" flexDirection="column" height="100vh" alignItems="center" justifyContent="center">
      <LoaderSpinner mx="3" spinnerLabel={text || defaultText} variant="action" />
    </Box>
  );
};
